import React from 'react';
import VideoWidget from './VideoWidget';
import ExternalLinks from './ExternalLinks';
import { ClonePlusVideoProps } from '@/components/chat/types';

const ClonePlusVideo: React.FC<ClonePlusVideoProps> = ({ cloneExtra }) => (
  <React.Fragment>
    <VideoWidget />
    {cloneExtra?.externalLinks?.length > 0 && (
      <ExternalLinks links={cloneExtra.externalLinks} className="tw-self-stretch tw-w-full tw-mt-3" />
    )}
  </React.Fragment>
);

export default ClonePlusVideo;
